module.exports = __webpack_public_path__ + "img/pic_4.a31e746d.png";